import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppService, BASE_URL_API } from '../../../app.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PersonService extends AppService {

  constructor(http: HttpClient) {
    super(http);
  }

  GetAll<T>(pi_rol_in_type: number, pi_per_in_document_type: number,pi_per_vc_document_number: string): Observable<any> {
    this.endpoint = `${BASE_URL_API}/person/${pi_rol_in_type}/`+pi_per_in_document_type+'/'+pi_per_vc_document_number;
    return this.get(this.endpoint);
  }
  
}
